import { Information } from '~/features/common/Taxipark/Information'

export const InformationPage = () => {
  return <Information />
}
